import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";
import { useScrollAnimation, fadeInUp, staggerContainer, AnimatedDiv, AnimatedH2 } from "@/hooks/useScrollAnimation";

const testimonials = [
  {
    name: "Darren Bishel",
    text: "As many farmers know, you don't have a lot of time for meetings and running around to sign papers, especially if you do all the tractor work and irrigation yourself. The experience I had selling our 20 acres in Fresno was none of that. Gurbir Samran handled all of that—good communications, coming by when papers needed signing, and had a good plan for selling the property. Overall, would recommend his services to others. Peace of mind goes a long way.",
  },
  {
    name: "Michael Klassen",
    text: "I recommend my family and friends to have Gurbir Samran and his team get involved with purchasing or selling their properties. I did not have any knowledge on how to sell my house, and I did not know who to turn to until I mentioned it to Gurbir. They sold my house for even more than I was asking for it. The process was fast and he guided me through the paperwork. Very professional and impressive!",
  },
  {
    name: "Stephen Dotta",
    text: "I would highly recommend Gurbir for all your real estate needs. He is the best agent in town!",
  },
];

const Testimonials = () => {
  const { ref, controls } = useScrollAnimation();

  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <AnimatedDiv
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={fadeInUp}
          className="text-center mb-16"
        >
          <p className="text-sm font-medium text-primary tracking-[0.3em] uppercase mb-4">Client Stories</p>
          <AnimatedH2 variants={fadeInUp} className="text-3xl md:text-5xl heading-luxury text-foreground mb-4">
            Testimonials
          </AnimatedH2>
          <div className="section-divider mt-4"></div>
        </AnimatedDiv>

        <AnimatedDiv
          initial="hidden"
          animate={controls}
          variants={staggerContainer}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto"
        >
          {testimonials.map((testimonial, index) => (
            <AnimatedDiv key={index} variants={fadeInUp} className="h-full">
              <Card className="bg-card border-0 shadow-lg h-full hover:shadow-xl transition-all duration-300">
                <CardContent className="p-8 flex flex-col h-full">
                  <Quote className="h-8 w-8 text-primary/30 mb-4" />
                  
                  <div className="flex gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-primary text-primary" />
                    ))}
                  </div>
                  
                  <p className="text-muted-foreground leading-relaxed mb-6 flex-grow italic">
                    "{testimonial.text}"
                  </p>
                  
                  <div className="border-t border-border pt-4">
                    <p className="font-semibold text-foreground">{testimonial.name}</p>
                  </div>
                </CardContent>
              </Card>
            </AnimatedDiv>
          ))}
        </AnimatedDiv>
      </div>
    </section>
  );
};

export default Testimonials;
